<i18n lang="yaml" src="@/locales/common.yaml"></i18n>

<template>
  <v-row gap="0">
    <v-col cols="12">
      <div class="h-100 d-flex flex-column justify-space-between">
        <div
          class="d-flex align-center"
          :class="$vuetify.display.xs ? 'flex-column' : 'flex-row'"
        >
          <CelusMonthPicker v-model="start" :max="end"></CelusMonthPicker>
          <v-divider
            :thickness="1"
            :class="$vuetify.display.xs ? 'w-100' : 'h-100'"
            :vertical="!$vuetify.display.xs"
          ></v-divider>
          <CelusMonthPicker
            v-model="end"
            :min="start ?? undefined"
          ></CelusMonthPicker>
        </div>
        <div class="d-flex justify-end w-100">
          <CelusTextButton class="mx-2 my-2" @click="$emit('close')">
            {{ $t("actions.close") }}
          </CelusTextButton>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import CelusMonthPicker from "@/components/util/CelusMonthPicker.vue";
import CelusTextButton from "@/components/util/CelusTextButton.vue";
import { ymDateFormat, ymDateParse } from "@/libs/dates";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "DateRangeSelector",
  components: { CelusMonthPicker, CelusTextButton },
  emits: ["close"],
  computed: {
    ...mapState({
      startRaw: "dateRangeStart",
    }),
    ...mapGetters({
      dateRange: "selectedDateRange",
      dateRangeExplicitEndText: "dateRangeExplicitEndText",
    }),
    start: {
      get() {
        return this.startRaw ? ymDateFormat(this.startRaw) : null;
      },
      set(value) {
        this.switchToCustomRange();
        this.setDateRangeStart(ymDateParse(value));
      },
    },
    end: {
      get() {
        return this.dateRangeExplicitEndText;
      },
      set(value) {
        this.switchToCustomRange();
        this.setDateRangeEnd(ymDateParse(value));
      },
    },
  },
  methods: {
    ...mapActions({
      setDateRangeName: "changeDateRangeObject",
      setDateRangeStart: "changeDateRangeStart",
      setDateRangeEnd: "changeDateRangeEnd",
    }),
    switchToCustomRange() {
      if (this.dateRange.custom) return;
      this.setDateRangeName("date_range.custom");
    },
  },
};
</script>
